import { CDMRecord } from '../../Common/DataOwnerModels/CDMRecord';
import { IEmployeeExperienceContext } from '@micro-frontend-react/employee-experience/lib/IEmployeeExperienceContext';
import { useContext, useEffect, useState, Context as ReactContext } from 'react';
import { Context } from '@micro-frontend-react/employee-experience/lib/Context';

export function useGetApprovedCdmsByRequest(requestId: string, shouldReload: boolean) {
  const [cdmList, setCdmList] = useState<CDMRecord[]>(null);
  const [cdmListLoading, setCdmListLoading] = useState<boolean>(true);
  const { httpClient } = useContext(Context as ReactContext<IEmployeeExperienceContext>);

  useEffect(() => {
    /*
      Checking for false boolean because it reloads twice when shouldReload mutates
      false -> true -> false
    */
    if (!shouldReload) {
      setCdmListLoading(true);
      httpClient
        .get<CDMRecord[]>(`${__API_BASE_URL__}/tenant/getCDMsByRequest?requestId=${requestId}`, {
          resource: __CLIENT_ID__,
        })
        .then(({ data }) => {
          setCdmList(data);
          setCdmListLoading(false);
        });
    }
  }, [httpClient, requestId, shouldReload]);

  return [cdmList, cdmListLoading] as const;
}

export function useGetApprovedCdmsByDataOwner(dataOwnerId: string, environment: number) {
  const { httpClient } = useContext(Context as ReactContext<IEmployeeExperienceContext>);
  const [approvedCdmList, setApprovedCdmList] = useState<CDMRecord[]>([]);
  const [isApprovedCdmListLoading, setIsApprovedCdmListLoading] = useState<boolean>(true);

  useEffect(() => {
    setIsApprovedCdmListLoading(true);
    httpClient
      .get<CDMRecord[]>(
        `${__API_BASE_URL__}/tenant/getApprovedCDMsByTenant?tenantId=${dataOwnerId}&environment=${environment}`,
        {
          resource: __CLIENT_ID__,
        }
      )
      .then(({ data }) => {
        const sortedCdmList = (data as CDMRecord[]).sort((a: CDMRecord, b: CDMRecord) => {
          return a.name < b.name ? -1 : a.name > b.name ? 1 : 0;
        });
        sortedCdmList?.map((x) => {
          x.environment = environment;
        });
        setApprovedCdmList(sortedCdmList);
        setIsApprovedCdmListLoading(false);
      });
  }, [dataOwnerId, environment]);

  return [approvedCdmList, isApprovedCdmListLoading] as const;
}
